import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCircleNotch } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';

const DevicePushStatusDisplay = ({ isPushing }) => {
  if (isPushing === null) {
    return (
      <span>
        <FontAwesomeIcon icon={faCircleNotch} className="text-muted" title="This device is not available." />
        {' '}
        Not Available
      </span>
    );
  }

  if (isPushing) {
    return (
      <span>
        <FontAwesomeIcon icon={faCircle} className="text-success" title="This device is pushing data to Room Alert Account." />
        {' '}
        Pushing
      </span>
    );
  }
  return (
    <span>
      <FontAwesomeIcon icon={faCircle} className="text-muted" title="This device is not pushing data to Room Alert Account." />
      {' '}
      Not Pushing
    </span>
  );
};

DevicePushStatusDisplay.propTypes = {
  isPushing: PropTypes.oneOf([true, false, null]),
};

DevicePushStatusDisplay.defaultProps = {
  isPushing: null,
};

export default DevicePushStatusDisplay;
